// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/nylas/v1/nylas.proto (package fingertip.creator.nylas.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Int32Value, proto3, Timestamp } from "@bufbuild/protobuf";
import { SiteIntegration } from "../../../common/type/v1/site_integration_pb.js";

/**
 * @generated from message fingertip.creator.nylas.v1.GenerateAuthUrlRequest
 */
export const GenerateAuthUrlRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.GenerateAuthUrlRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "success_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.GenerateAuthUrlResponse
 */
export const GenerateAuthUrlResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.GenerateAuthUrlResponse",
  () => [
    { no: 1, name: "auth_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.CompleteAuthRequest
 */
export const CompleteAuthRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.CompleteAuthRequest",
  () => [
    { no: 1, name: "auth_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.CompleteAuthResponse
 */
export const CompleteAuthResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.CompleteAuthResponse",
  () => [
    { no: 1, name: "site_integration", kind: "message", T: SiteIntegration },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.GetSiteAvailabilityByDayRequest
 */
export const GetSiteAvailabilityByDayRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.GetSiteAvailabilityByDayRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "range_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "range_end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "client_time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 7, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "custom_length", kind: "message", T: Int32Value },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.SiteAvailabilityByDayGroupClassInfo
 */
export const SiteAvailabilityByDayGroupClassInfo = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.SiteAvailabilityByDayGroupClassInfo",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "available", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "max", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "waitlist_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.SiteAvailabilityByDayUserInfo
 */
export const SiteAvailabilityByDayUserInfo = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.SiteAvailabilityByDayUserInfo",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.SiteAvailabilityByDayTimeSlot
 */
export const SiteAvailabilityByDayTimeSlot = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.SiteAvailabilityByDayTimeSlot",
  () => [
    { no: 1, name: "users", kind: "message", T: SiteAvailabilityByDayUserInfo, repeated: true },
    { no: 2, name: "time", kind: "message", T: Timestamp },
    { no: 3, name: "group_class", kind: "message", T: SiteAvailabilityByDayGroupClassInfo },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.GetSiteAvailabilityByDayResponse
 */
export const GetSiteAvailabilityByDayResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.GetSiteAvailabilityByDayResponse",
  () => [
    { no: 1, name: "time_slots", kind: "message", T: SiteAvailabilityByDayTimeSlot, repeated: true },
    { no: 2, name: "connections_found", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.ConnectZoomAuthUrlRequest
 */
export const ConnectZoomAuthUrlRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.ConnectZoomAuthUrlRequest",
  () => [
    { no: 1, name: "site_integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.ConnectZoomAuthUrlResponse
 */
export const ConnectZoomAuthUrlResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.ConnectZoomAuthUrlResponse",
  () => [
    { no: 1, name: "auth_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.CompleteConnectorAuthRequest
 */
export const CompleteConnectorAuthRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.CompleteConnectorAuthRequest",
  () => [
    { no: 1, name: "auth_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.CompleteConnectorAuthResponse
 */
export const CompleteConnectorAuthResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.CompleteConnectorAuthResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.SynchronizeCalendarRequest
 */
export const SynchronizeCalendarRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.SynchronizeCalendarRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "nylas_site_integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.nylas.v1.SynchronizeCalendarResponse
 */
export const SynchronizeCalendarResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.nylas.v1.SynchronizeCalendarResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

